import * as autobind from 'autobind';
import React, { PureComponent } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Button, Container, Modal, Icon, Header } from 'semantic-ui-react';
import { InstructorExpertiseDto, InstructorExpertiseStore } from 'stores/skills/instructor-expertise-store';
import { connect } from 'redux-scaffolding-ts';
import { UserDto, UserStore } from 'stores/users/users-store';
import './choose-instructors-form.less';
import TailwindMultipleInstructorEditor from 'widgets/bussiness/multiple-selector/multiple-instructor-editor-tw';

interface TailwindChooseInstructorsWithGhostsViewProps extends WithTranslation {
  onSelectInstructors?: (instructorExpertises: InstructorExpertiseDto[]) => void;
  onCloseModal?: () => void;
  instructorExpertisesStore?: InstructorExpertiseStore;
  users?: UserStore;
  onlyInstructorsPlannerTFT?: boolean;
  onlyInstructorsPlannerMTC?: boolean;
}

interface TailwindChooseInstructorsWithGhostsViewState {
  instructorExpertises: InstructorExpertiseDto[];
  selectedInstructors: UserDto[];
}

@connect(['instructorExpertisesStore', InstructorExpertiseStore], ['users', UserStore])
class TailwindChooseInstructorsWithGhostsView extends PureComponent<
  TailwindChooseInstructorsWithGhostsViewProps,
  TailwindChooseInstructorsWithGhostsViewState
> {
  timer: any = null;

  constructor(props: TailwindChooseInstructorsWithGhostsViewProps) {
    super(props);

    this.state = {
      selectedInstructors: [],
      instructorExpertises: []
    };
  }

  @autobind
  private onAddParticipants() {
    if (this.props.onSelectInstructors) this.props.onSelectInstructors(this.state.instructorExpertises);
    if (this.props.onCloseModal) this.props.onCloseModal();
  }

  @autobind
  private onCancel() {
    if (this.props.onCloseModal) this.props.onCloseModal();
  }

  selectedInsctructor(items: InstructorExpertiseDto[]): void {
    const instructorExpertisesCopy = [...this.state.instructorExpertises, ...items];
    const instructors = items.map(item => item.user); // Extraer solo los users
    const itemsToAdd = (instructors as UserDto[]).filter(item => !this.state.selectedInstructors.some(i => i.id === item.id));
    const selectedInstructorsCopy = [...this.state.selectedInstructors, ...itemsToAdd];
    this.setState({ instructorExpertises: instructorExpertisesCopy, selectedInstructors: selectedInstructorsCopy });
  }

  renderSelectedIcon(isSelected: boolean) {
    if (!isSelected) return <></>;

    return <Icon name="check" color="black" />;
  }

  public render() {
    const { t } = this.props;

    return (
      <Modal
        size="large"
        className="modal-transparent choose-instructors__modal"
        open
        closeOnEscape={true}
        onClose={this.onCancel}
        onCloseUsersModal={this.onCancel}
      >
        <Modal.Header className="search__modal__header">
          <Header as="h2" className="modal-header-title">
            {t('Instructor Search')}
          </Header>
        </Modal.Header>
        <Modal.Content className="modal-content">
          <Container className="student-list-table choose-instructor-form__table-wrapper">
            <TailwindMultipleInstructorEditor
              clearable
              placeholder={t('Instructor Name')}
              value={this.state.selectedInstructors}
              onChange={instructorExp => this.selectedInsctructor(instructorExp)}
            />
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancel}>
            {t('Cancel')}
          </Button>
          <Button className="add-participants-button" onClick={this.onAddParticipants} positive>
            {t('Add Instructor')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(TailwindChooseInstructorsWithGhostsView);
